<form
  class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
  novalidate="novalidate"
  [formGroup]="form"
  id="kt_login_password_reset_form"
  [loader]="loading$ | async"
>
  <div class="text-center mb-10">
    <h1 class="text-dark mb-3">Reenvio de Senha</h1>
    <div class="text-gray-400 fs-4">
      Te enviaremos um e-mail de confirmação para geração da nova senha
    </div>
  </div>

  <div class="fv-row mb-10">
    <label class="form-label text-gray-900 fs-6">Email</label>
    <input
      class="form-control form-control-lg form-control-solid"
      type="email"
      formControlName="email"
      placeholder="Email"
      name="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': form.controls['email'].invalid,
        'is-valid': form.controls['email'].valid
      }"
    />

    <app-field-control-error
      [control]="form.get('email')"
      label="E-mail"
    ></app-field-control-error>
  </div>
  <div class="d-flex flex-wrap justify-content-center pb-lg-0">
    <button
      type="submit"
      id="kt_password_reset_submit"
      class="btn btn-lg btn-primary me-4"
      (click)="submit()"
    >
      <span class="indicator-label">Enviar</span>
      <ng-container *ngIf="loadingSubject.value">
        <span class="indicator-progress">
          Aguarde...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </ng-container>
    </button>
    <a
      [routerLink]="['/auth/login']"
      id="kt_login_password_reset_form_cancel_button"
      class="btn btn-lg btn-light"
    >
      Cancelar
    </a>
  </div>
</form>
